<template lang="pug">
section
  header.header-settings
    .tabs
      .tab.primary-text.active
        span Slack

  has-access(allowance="integration.slack")
    AlertBox(v-if="alert", :type="alert.type", :text="alert.text")

    section.sub-section(v-if="!configuration.vendor_data")
      p Enable Slack and get feedback as it happens!
      a(href="#", @click.prevent="connect()")
        img(
          alt="Add to Slack",
          height="40",
          width="139",
          src="https://platform.slack-edge.com/img/add_to_slack.png",
          srcset="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
        )

    div(v-if="configuration.vendor_data")
      .info-field
        h6 Channel
        p {{ configuration.vendor_data.incoming_webhook.channel }}

      .info-field
        h6 Configuration Url
        p {{ configuration.vendor_data.incoming_webhook.configuration_url }}

      form(@keyup.enter="submit", @submit.prevent="submit")
        .form-field-group.no-padding
          h6 Notifications
          .form-field(v-for="(value, key) in configuration.notifications")
            .form-field-toggle
              label.toggle-switch
                .row.center
                  .col
                    input(
                      type="checkbox",
                      v-model="configuration.notifications[key]"
                    )
                    .toggle-switch-slider
                      .toggle-switch-knob
                  .col
                    div
                      span {{ slackKeyMapper[key].label }}
        .form-field
          SubmitButton(label="Save", :formState="formState")

      section.sub-section
        p We can't imagine why you'd want to do this but you can.
        button.button.button-alert(type="button", @click="remove") Remove Integration
</template>

<script>
import { mapState } from 'vuex'

const slackAuthUrl =
  'https://slack.com/oauth/v2/authorize?client_id=819410061280.820965185840&scope=channels:join,chat:write,commands,channels:read,users:read,users:read.email&user_scope='

const slackKeyMapper = {
  board_added: {
    label: 'Boards created'
  },
  feature_added: {
    label: 'Features created'
  },
  feature_assigned: {
    label: 'Features assigned'
  },
  feature_liked: {
    label: 'Features voted on'
  },
  feature_commented: {
    label: 'Features commented on'
  },
  feature_status_changed: {
    label: 'Feature status changes'
  }
}

export default {
  name: 'SettingsSlack',
  components: {},
  beforeCreate() {},
  mounted() {
    this.getIntegration()
  },
  data() {
    return {
      alert: null,
      slackKeyMapper,
      configuration: {},
      formState: 'initial'
    }
  },
  computed: {},
  methods: {
    oAuthListener(msg) {
      // console.log('oAuthListener', msg)
      const authSuccess = msg.data.data === 'auth_success'
      const authError = msg.data.data === 'auth_failure'

      if (authSuccess) {
        this.getIntegration()
        this.alert = {
          type: 'info',
          text: 'Success'
        }
      }

      if (authError) {
        this.alert = {
          type: 'danger',
          text: msg.data.errorMsg
        }
      }
    },

    connect() {
      const height = 600
      const width = 500
      const left = window.screen.width / 2 - (width / 2 + 10)
      const top = window.screen.height / 2 - (height / 2 + 50)

      const params =
        'status=no,height=' +
        height +
        ',width=' +
        width +
        ',resizable=yes,left=' +
        left +
        ',top=' +
        top +
        ',screenX=' +
        left +
        ',screenY=' +
        top +
        ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no'

      const popup = window.open(slackAuthUrl, 'SlackAuth', params)

      window.addEventListener('message', this.oAuthListener)

      this.$once('hook:destroyed', () => {
        console.log('hook:destroy')
        window.removeEventListener('message', this.oAuthListener)
      })
    },
    getIntegration() {
      this.$store
        .dispatch('integrations/getIntegration', 'slack')
        .then((integration) => {
          if (integration && integration.configuration) {
            this.configuration = integration.configuration
          }
        })
    },
    submit() {
      let data = {
        notifications: this.configuration.notifications
      }
      this.formState = 'pending'
      this.$store
        .dispatch('integrations/putIntegrationConfiguration', {
          type: 'slack',
          configuration: data
        })
        .then(
          (integration) => {
            this.configuration = integration.configuration
            this.formState = 'success'
          },
          (errors) => {
            this.errors = errors
            console.log(errors)
          }
        )
    },

    remove() {
      this.$store.dispatch('integrations/deleteIntegration', 'slack').then(
        () => {
          this.configuration = {}
        },
        (errors) => {
          this.errors = errors
          console.log(errors)
        }
      )
    }
  }
}
</script>

<style lang="stylus" scoped></style>
